"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _wechatOpenPlatformApi = require("@/api/wechatOpenPlatformApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var createEmptyDomainForm = function createEmptyDomainForm() {
  return {
    requestDomains: '',
    wsRequestDomains: '',
    uploadDomains: '',
    downloadDomains: '',
    webViewDomains: ''
  };
};
var createEmptyPrivacyForm = function createEmptyPrivacyForm() {
  return {
    ownerSetting: {
      contactEmail: '',
      contactPhone: '',
      contactQq: '',
      contactWeixin: '',
      extFileMediaId: '',
      noticeMethod: '',
      storeExpireDays: null
    },
    settings: []
  };
};
var createEmptyOrderPathForm = function createEmptyOrderPathForm() {
  return {
    path: '',
    imageUrls: '',
    video: '',
    testAccount: '',
    testPassword: '',
    testRemark: ''
  };
};
var createEmptyQrcodeForm = function createEmptyQrcodeForm() {
  return {
    prefix: '',
    path: '',
    isEdit: 0,
    openVersion: 2,
    permitSubRule: 1,
    debugUrls: ''
  };
};
var createEmptyLocationForm = function createEmptyLocationForm() {
  return {
    apiName: '',
    apiChName: '',
    content: '',
    urlList: '',
    picList: '',
    videoList: ''
  };
};
var createAppealMaterial = function createAppealMaterial() {
  return {
    reason: '',
    proofMaterialIds: [],
    uploading: false
  };
};
var _default = exports.default = {
  name: 'ReleasePreparation',
  data: function data() {
    return {
      platforms: [],
      apps: [],
      platformId: null,
      companyAppId: null,
      activeTab: 'basic',
      basicInfo: {},
      basicSignature: '',
      basicInfoLoading: false,
      basicSignatureSaving: false,
      basicHeadImageSaving: false,
      orderPathForm: createEmptyOrderPathForm(),
      orderPathApplying: false,
      memberConfig: {},
      memberLoading: false,
      testerWechatId: '',
      testerBinding: false,
      testerUnbindingUserStr: '',
      precheck: {},
      precheckLoading: false,
      domainLoading: false,
      serverDomainSaving: false,
      webViewDomainSaving: false,
      domainForm: createEmptyDomainForm(),
      categoryLoading: false,
      categorySaving: false,
      categoryError: '',
      categoryConfig: {},
      categoryDialogVisible: false,
      categoryDialogMode: 'add',
      categoryForm: {
        categoryKey: '',
        qualificationGroupIndex: null,
        certificates: []
      },
      privacyVersion: 2,
      privacyLoading: false,
      privacySaving: false,
      privacyConfig: {},
      privacyForm: createEmptyPrivacyForm(),
      qrcodeConfig: {},
      qrcodeLoading: false,
      qrcodeSaving: false,
      qrcodeDialogVisible: false,
      qrcodeForm: createEmptyQrcodeForm(),
      locationConfig: {},
      locationLoading: false,
      locationApplying: false,
      locationDialogVisible: false,
      locationForm: createEmptyLocationForm(),
      illegalConfig: {},
      illegalLoading: false,
      illegalDateRange: [],
      illegalDatePickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      appealRecordsVisible: false,
      appealRecordsLoading: false,
      appealRecords: [],
      appealDialogVisible: false,
      appealSubmitting: false,
      appealForm: {
        illegalRecordId: '',
        appealMaterials: [createAppealMaterial()]
      }
    };
  },
  computed: {
    selectedCategory: function selectedCategory() {
      var _this = this;
      return (this.categoryConfig.availableCategories || []).find(function (item) {
        return "".concat(item.firstId, ":").concat(item.secondId) === _this.categoryForm.categoryKey;
      }) || null;
    },
    qualificationGroups: function qualificationGroups() {
      return this.selectedCategory && Array.isArray(this.selectedCategory.qualificationGroups) ? this.selectedCategory.qualificationGroups : [];
    },
    privacyKeyOptions: function privacyKeyOptions() {
      var options = _toConsumableArray(this.privacyConfig && this.privacyConfig.privacyKeyOptions || []);
      var keys = new Set(options.map(function (item) {
        return item.key;
      }));
      var dynamicKeys = [].concat(_toConsumableArray(this.privacyConfig && this.privacyConfig.privacyList || []), _toConsumableArray(this.privacyForm.settings.map(function (item) {
        return item.privacyKey;
      }))).filter(Boolean);
      dynamicKeys.forEach(function (key) {
        if (!keys.has(key)) {
          options.push({
            key: key,
            label: key
          });
          keys.add(key);
        }
      });
      return options;
    },
    orderPathRows: function orderPathRows() {
      return [_objectSpread({
        versionLabel: '线上版'
      }, this.basicInfo.onlineOrderPath || {}), _objectSpread({
        versionLabel: '审核版'
      }, this.basicInfo.auditOrderPath || {})];
    }
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var ready, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return (0, _wechatOpenPlatformApi.getPlatformList)();
          case 1:
            _t = _context.v;
            if (_t) {
              _context.n = 2;
              break;
            }
            _t = [];
          case 2:
            this.platforms = _t;
            ready = this.platforms.find(function (item) {
              return item.enabled === 1;
            });
            if (!ready) {
              _context.n = 3;
              break;
            }
            this.platformId = ready.id;
            _context.n = 3;
            return this.loadApps();
          case 3:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    contextParams: function contextParams() {
      return {
        platformId: this.platformId,
        companyAppId: this.companyAppId
      };
    },
    handlePlatformChange: function () {
      var _handlePlatformChange = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.companyAppId = null;
              _context2.n = 1;
              return this.loadApps();
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handlePlatformChange() {
        return _handlePlatformChange.apply(this, arguments);
      }
      return handlePlatformChange;
    }(),
    loadApps: function () {
      var _loadApps = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (this.platformId) {
                _context3.n = 1;
                break;
              }
              this.apps = [];
              return _context3.a(2);
            case 1:
              _context3.n = 2;
              return (0, _wechatOpenPlatformApi.getAuthorizerAppList)({
                platformId: this.platformId,
                authorizationStatus: 'AUTHORIZED',
                page: 1,
                limit: 1000
              });
            case 2:
              data = _context3.v;
              this.apps = data.list || [];
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadApps() {
        return _loadApps.apply(this, arguments);
      }
      return loadApps;
    }(),
    handleAppChange: function handleAppChange() {
      this.basicInfo = {};
      this.basicSignature = '';
      this.orderPathForm = createEmptyOrderPathForm();
      this.memberConfig = {};
      this.testerWechatId = '';
      this.testerUnbindingUserStr = '';
      this.precheck = {};
      this.domainForm = createEmptyDomainForm();
      this.categoryConfig = {};
      this.privacyConfig = {};
      this.qrcodeConfig = {};
      this.locationConfig = {};
      this.illegalConfig = {};
      this.illegalDateRange = [];
      this.loadActiveTab();
    },
    handleTabClick: function handleTabClick() {
      this.loadActiveTab();
    },
    loadActiveTab: function loadActiveTab() {
      if (!this.companyAppId) return;
      if (this.activeTab === 'basic') return this.loadBasicInfo();
      if (this.activeTab === 'member') return this.loadMemberConfig();
      if (this.activeTab === 'precheck') return this.loadPrecheck();
      if (this.activeTab === 'domain') return this.loadDomain();
      if (this.activeTab === 'category') return this.loadCategory();
      if (this.activeTab === 'privacy') return this.loadPrivacy();
      if (this.activeTab === 'qrcode') return this.loadQrcodeRules();
      if (this.activeTab === 'location') return this.loadLocationInterfaces();
      if (this.activeTab === 'violation') return this.loadIllegalRecords();
    },
    loadBasicInfo: function () {
      var _loadBasicInfo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.basicInfoLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppBasicInfo)(this.contextParams());
            case 2:
              this.basicInfo = _context4.v;
              this.basicSignature = this.basicInfo.signatureInfo && this.basicInfo.signatureInfo.signature || '';
              this.applyOrderPathFormData();
            case 3:
              _context4.p = 3;
              this.basicInfoLoading = false;
              return _context4.f(3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[1,, 3, 4]]);
      }));
      function loadBasicInfo() {
        return _loadBasicInfo.apply(this, arguments);
      }
      return loadBasicInfo;
    }(),
    applyOrderPathFormData: function applyOrderPathFormData() {
      var audit = this.basicInfo.auditOrderPath || {};
      var online = this.basicInfo.onlineOrderPath || {};
      var source = audit.configured ? audit : online;
      this.orderPathForm = {
        path: source.path || '',
        imageUrls: this.listToText(source.imageList),
        video: source.video || '',
        testAccount: source.testAccount || '',
        testPassword: '',
        testRemark: source.testRemark || ''
      };
    },
    realnameStatusLabel: function realnameStatusLabel(status) {
      return {
        1: '实名成功',
        2: '实名中',
        3: '实名失败'
      }[status] || '未知';
    },
    realnameStatusType: function realnameStatusType(status) {
      return {
        1: 'success',
        2: 'warning',
        3: 'danger'
      }[status] || 'info';
    },
    quotaText: function quotaText(info) {
      if (!info || info.modifyQuota === undefined || info.modifyQuota === null) return '-';
      return "".concat(info.modifyUsedCount || 0, " / ").concat(info.modifyQuota);
    },
    orderPathStatusLabel: function orderPathStatusLabel(row) {
      if (!row.configured && !row.status) return '未配置';
      return {
        2: '审核中',
        3: '审核失败',
        4: '审核通过'
      }[row.status] || '已配置';
    },
    orderPathStatusType: function orderPathStatusType(status) {
      return {
        2: 'warning',
        3: 'danger',
        4: 'success'
      }[status] || 'info';
    },
    beforeBasicHeadImageUpload: function beforeBasicHeadImageUpload(file) {
      if (!/\.(jpe?g|png|bmp|gif)$/i.test(file.name || '')) {
        this.$message.warning('头像图片仅支持jpg、jpeg、png、bmp、gif格式');
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning('头像图片大小不能超过2MB');
        return false;
      }
      return true;
    },
    uploadBasicHeadImage: function () {
      var _uploadBasicHeadImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(options) {
        var formData, _t2;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              formData = new FormData();
              formData.append('platformId', this.platformId);
              formData.append('companyAppId', this.companyAppId);
              formData.append('file', options.file);
              this.basicHeadImageSaving = true;
              _context5.p = 1;
              _context5.n = 2;
              return (0, _wechatOpenPlatformApi.saveOpenAppBasicHeadImage)(formData);
            case 2:
              this.basicInfo = _context5.v;
              this.basicSignature = this.basicInfo.signatureInfo && this.basicInfo.signatureInfo.signature || '';
              if (options.onSuccess) options.onSuccess(this.basicInfo);
              this.$message.success('小程序头像已修改');
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t2 = _context5.v;
              if (options.onError) options.onError(_t2);
            case 4:
              _context5.p = 4;
              this.basicHeadImageSaving = false;
              return _context5.f(4);
            case 5:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function uploadBasicHeadImage(_x) {
        return _uploadBasicHeadImage.apply(this, arguments);
      }
      return uploadBasicHeadImage;
    }(),
    saveBasicSignature: function () {
      var _saveBasicSignature = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var signature;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              signature = String(this.basicSignature || '').trim();
              if (!(signature.length < 4 || signature.length > 120)) {
                _context6.n = 1;
                break;
              }
              this.$message.warning('功能介绍长度必须为4-120个字符');
              return _context6.a(2);
            case 1:
              this.basicSignatureSaving = true;
              _context6.p = 2;
              _context6.n = 3;
              return (0, _wechatOpenPlatformApi.saveOpenAppBasicSignature)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                signature: signature
              }));
            case 3:
              this.basicInfo = _context6.v;
              this.basicSignature = this.basicInfo.signatureInfo && this.basicInfo.signatureInfo.signature || signature;
              this.$message.success('功能介绍已保存');
            case 4:
              _context6.p = 4;
              this.basicSignatureSaving = false;
              return _context6.f(4);
            case 5:
              return _context6.a(2);
          }
        }, _callee6, this, [[2,, 4, 5]]);
      }));
      function saveBasicSignature() {
        return _saveBasicSignature.apply(this, arguments);
      }
      return saveBasicSignature;
    }(),
    applyOrderPath: function () {
      var _applyOrderPath = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var path, data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              path = String(this.orderPathForm.path || '').trim();
              if (path) {
                _context7.n = 1;
                break;
              }
              this.$message.warning('请填写订单页Path');
              return _context7.a(2);
            case 1:
              if (!(path.startsWith('/') || path.includes('://'))) {
                _context7.n = 2;
                break;
              }
              this.$message.warning('订单页Path应类似pages/order/list，不能以/开头');
              return _context7.a(2);
            case 2:
              this.orderPathApplying = true;
              _context7.p = 3;
              _context7.n = 4;
              return (0, _wechatOpenPlatformApi.applyOpenAppOrderPath)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                path: path,
                imageUrls: this.textToList(this.orderPathForm.imageUrls),
                video: this.orderPathForm.video,
                testAccount: this.orderPathForm.testAccount,
                testPassword: this.orderPathForm.testPassword,
                testRemark: this.orderPathForm.testRemark
              }));
            case 4:
              data = _context7.v;
              this.orderPathForm.testPassword = '';
              this.$message.success(data && data.message || '订单页Path申请已提交');
              _context7.n = 5;
              return this.loadBasicInfo();
            case 5:
              _context7.p = 5;
              this.orderPathApplying = false;
              return _context7.f(5);
            case 6:
              return _context7.a(2);
          }
        }, _callee7, this, [[3,, 5, 6]]);
      }));
      function applyOrderPath() {
        return _applyOrderPath.apply(this, arguments);
      }
      return applyOrderPath;
    }(),
    loadMemberConfig: function () {
      var _loadMemberConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              this.memberLoading = true;
              _context8.p = 1;
              _context8.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppMemberConfig)(this.contextParams());
            case 2:
              this.memberConfig = _context8.v;
            case 3:
              _context8.p = 3;
              this.memberLoading = false;
              return _context8.f(3);
            case 4:
              return _context8.a(2);
          }
        }, _callee8, this, [[1,, 3, 4]]);
      }));
      function loadMemberConfig() {
        return _loadMemberConfig.apply(this, arguments);
      }
      return loadMemberConfig;
    }(),
    bindTester: function () {
      var _bindTester = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
        var wechatId;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              wechatId = String(this.testerWechatId || '').trim();
              if (wechatId) {
                _context9.n = 1;
                break;
              }
              this.$message.warning('请输入体验者微信号');
              return _context9.a(2);
            case 1:
              this.testerBinding = true;
              _context9.p = 2;
              _context9.n = 3;
              return (0, _wechatOpenPlatformApi.bindOpenAppTester)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                wechatId: wechatId
              }));
            case 3:
              this.memberConfig = _context9.v;
              this.testerWechatId = '';
              this.$message.success('体验者绑定成功');
            case 4:
              _context9.p = 4;
              this.testerBinding = false;
              return _context9.f(4);
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[2,, 4, 5]]);
      }));
      function bindTester() {
        return _bindTester.apply(this, arguments);
      }
      return bindTester;
    }(),
    unbindTester: function () {
      var _unbindTester = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(row) {
        var _t3;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              if (!(!row || !row.userStr)) {
                _context0.n = 1;
                break;
              }
              return _context0.a(2);
            case 1:
              _context0.p = 1;
              _context0.n = 2;
              return this.$confirm('确认解除该体验者与当前小程序的绑定？', '解绑体验者', {
                type: 'warning'
              });
            case 2:
              _context0.n = 4;
              break;
            case 3:
              _context0.p = 3;
              _t3 = _context0.v;
              return _context0.a(2);
            case 4:
              this.testerUnbindingUserStr = row.userStr;
              _context0.p = 5;
              _context0.n = 6;
              return (0, _wechatOpenPlatformApi.unbindOpenAppTester)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                userStr: row.userStr
              }));
            case 6:
              this.memberConfig = _context0.v;
              this.$message.success('体验者解绑成功');
            case 7:
              _context0.p = 7;
              this.testerUnbindingUserStr = '';
              return _context0.f(7);
            case 8:
              return _context0.a(2);
          }
        }, _callee0, this, [[5,, 7, 8], [1, 3]]);
      }));
      function unbindTester(_x2) {
        return _unbindTester.apply(this, arguments);
      }
      return unbindTester;
    }(),
    loadPrecheck: function () {
      var _loadPrecheck = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              this.precheckLoading = true;
              _context1.p = 1;
              _context1.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppReleasePrecheck)(this.contextParams());
            case 2:
              this.precheck = _context1.v;
            case 3:
              _context1.p = 3;
              this.precheckLoading = false;
              return _context1.f(3);
            case 4:
              return _context1.a(2);
          }
        }, _callee1, this, [[1,, 3, 4]]);
      }));
      function loadPrecheck() {
        return _loadPrecheck.apply(this, arguments);
      }
      return loadPrecheck;
    }(),
    listToText: function listToText(list) {
      return (list || []).join('\n');
    },
    textToList: function textToList(value) {
      return _toConsumableArray(new Set(String(value || '').split(/\r?\n/).map(function (item) {
        return item.trim();
      }).filter(Boolean)));
    },
    applyDomainData: function applyDomainData(data) {
      this.domainForm = {
        requestDomains: this.listToText(data.requestDomains),
        wsRequestDomains: this.listToText(data.wsRequestDomains),
        uploadDomains: this.listToText(data.uploadDomains),
        downloadDomains: this.listToText(data.downloadDomains),
        webViewDomains: this.listToText(data.webViewDomains)
      };
    },
    loadDomain: function () {
      var _loadDomain = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _t4;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              this.domainLoading = true;
              _context10.p = 1;
              _t4 = this;
              _context10.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppDomainConfig)(this.contextParams());
            case 2:
              _t4.applyDomainData.call(_t4, _context10.v);
            case 3:
              _context10.p = 3;
              this.domainLoading = false;
              return _context10.f(3);
            case 4:
              return _context10.a(2);
          }
        }, _callee10, this, [[1,, 3, 4]]);
      }));
      function loadDomain() {
        return _loadDomain.apply(this, arguments);
      }
      return loadDomain;
    }(),
    saveServerDomains: function () {
      var _saveServerDomains = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
        var data;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.p = _context11.n) {
            case 0:
              this.serverDomainSaving = true;
              _context11.p = 1;
              _context11.n = 2;
              return (0, _wechatOpenPlatformApi.saveOpenAppServerDomains)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                requestDomains: this.textToList(this.domainForm.requestDomains),
                wsRequestDomains: this.textToList(this.domainForm.wsRequestDomains),
                uploadDomains: this.textToList(this.domainForm.uploadDomains),
                downloadDomains: this.textToList(this.domainForm.downloadDomains)
              }));
            case 2:
              data = _context11.v;
              this.applyDomainData(data);
              this.$message.success('服务器域名已保存');
            case 3:
              _context11.p = 3;
              this.serverDomainSaving = false;
              return _context11.f(3);
            case 4:
              return _context11.a(2);
          }
        }, _callee11, this, [[1,, 3, 4]]);
      }));
      function saveServerDomains() {
        return _saveServerDomains.apply(this, arguments);
      }
      return saveServerDomains;
    }(),
    saveWebViewDomains: function () {
      var _saveWebViewDomains = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
        var data;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.p = _context12.n) {
            case 0:
              this.webViewDomainSaving = true;
              _context12.p = 1;
              _context12.n = 2;
              return (0, _wechatOpenPlatformApi.saveOpenAppWebViewDomains)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                webViewDomains: this.textToList(this.domainForm.webViewDomains)
              }));
            case 2:
              data = _context12.v;
              this.applyDomainData(data);
              this.$message.success('业务域名已保存');
            case 3:
              _context12.p = 3;
              this.webViewDomainSaving = false;
              return _context12.f(3);
            case 4:
              return _context12.a(2);
          }
        }, _callee12, this, [[1,, 3, 4]]);
      }));
      function saveWebViewDomains() {
        return _saveWebViewDomains.apply(this, arguments);
      }
      return saveWebViewDomains;
    }(),
    loadCategory: function () {
      var _loadCategory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
        var _t5;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              this.categoryLoading = true;
              this.categoryError = '';
              _context13.p = 1;
              _context13.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppCategoryConfig)(this.contextParams());
            case 2:
              this.categoryConfig = _context13.v;
              _context13.n = 4;
              break;
            case 3:
              _context13.p = 3;
              _t5 = _context13.v;
              this.categoryConfig = {};
              this.categoryError = typeof _t5 === 'string' ? _t5 : '类目配置读取失败，请确认已授权权限集30';
            case 4:
              _context13.p = 4;
              this.categoryLoading = false;
              return _context13.f(4);
            case 5:
              return _context13.a(2);
          }
        }, _callee13, this, [[1, 3, 4, 5]]);
      }));
      function loadCategory() {
        return _loadCategory.apply(this, arguments);
      }
      return loadCategory;
    }(),
    categoryAuditLabel: function categoryAuditLabel(status) {
      return {
        1: '审核中',
        2: '未通过',
        3: '已通过'
      }[status] || '未知';
    },
    categoryAuditType: function categoryAuditType(status) {
      return {
        1: 'warning',
        2: 'danger',
        3: 'success'
      }[status] || 'info';
    },
    openCategoryDialog: function openCategoryDialog(mode, row) {
      this.categoryDialogMode = mode;
      this.categoryForm = {
        categoryKey: row ? "".concat(row.first, ":").concat(row.second) : '',
        qualificationGroupIndex: null,
        certificates: []
      };
      if (row) this.handleCategorySelectionChange();
      this.categoryDialogVisible = true;
    },
    handleCategorySelectionChange: function handleCategorySelectionChange() {
      var groups = this.qualificationGroups;
      this.categoryForm.qualificationGroupIndex = groups.length ? groups[0].index : null;
      this.applyQualificationGroup();
    },
    applyQualificationGroup: function applyQualificationGroup() {
      var _this2 = this;
      var group = this.qualificationGroups.find(function (item) {
        return item.index === _this2.categoryForm.qualificationGroupIndex;
      });
      this.categoryForm.certificates = group ? (group.certificates || []).map(function (item) {
        return {
          key: item.name,
          value: '',
          exampleUrl: item.exampleUrl || '',
          fileName: '',
          uploading: false
        };
      }) : [];
    },
    beforeCategoryCertificateUpload: function beforeCategoryCertificateUpload(file) {
      var supported = /\.(jpe?g|png|bmp|gif)$/i.test(file.name || '');
      if (!supported) {
        this.$message.warning('资质图片仅支持jpg、jpeg、png、bmp、gif格式');
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning('资质图片大小不能超过2MB');
        return false;
      }
      return true;
    },
    uploadCategoryCertificate: function () {
      var _uploadCategoryCertificate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(options, index) {
        var certificate, formData, data, _t6;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.p = _context14.n) {
            case 0:
              certificate = this.categoryForm.certificates[index];
              if (certificate) {
                _context14.n = 1;
                break;
              }
              return _context14.a(2);
            case 1:
              formData = new FormData();
              formData.append('platformId', this.platformId);
              formData.append('companyAppId', this.companyAppId);
              formData.append('file', options.file);
              this.$set(certificate, 'uploading', true);
              _context14.p = 2;
              _context14.n = 3;
              return (0, _wechatOpenPlatformApi.uploadOpenAppCategoryCertificate)(formData);
            case 3:
              data = _context14.v;
              this.$set(certificate, 'value', data.mediaId || '');
              this.$set(certificate, 'fileName', data.fileName || options.file.name);
              if (options.onSuccess) options.onSuccess(data);
              this.$message.success('资质图片已上传到微信');
              _context14.n = 5;
              break;
            case 4:
              _context14.p = 4;
              _t6 = _context14.v;
              if (options.onError) options.onError(_t6);
            case 5:
              _context14.p = 5;
              this.$set(certificate, 'uploading', false);
              return _context14.f(5);
            case 6:
              return _context14.a(2);
          }
        }, _callee14, this, [[2, 4, 5, 6]]);
      }));
      function uploadCategoryCertificate(_x3, _x4) {
        return _uploadCategoryCertificate.apply(this, arguments);
      }
      return uploadCategoryCertificate;
    }(),
    saveCategory: function () {
      var _saveCategory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
        var ids, certificates, payload, _t7;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.p = _context15.n) {
            case 0:
              ids = String(this.categoryForm.categoryKey || '').split(':').map(Number);
              if (!(!ids[0] || !ids[1])) {
                _context15.n = 1;
                break;
              }
              this.$message.warning('请选择小程序类目');
              return _context15.a(2);
            case 1:
              if (!(this.selectedCategory && this.selectedCategory.sensitiveType === 1 && !this.qualificationGroups.length)) {
                _context15.n = 2;
                break;
              }
              this.$message.warning('微信未返回该敏感类目的资质清单，暂时无法提交');
              return _context15.a(2);
            case 2:
              certificates = this.categoryForm.certificates.filter(function (item) {
                return item.key || item.value;
              }).map(function (item) {
                return {
                  key: item.key,
                  value: item.value
                };
              });
              if (!certificates.some(function (item) {
                return !item.key || !item.value;
              })) {
                _context15.n = 3;
                break;
              }
              this.$message.warning('请上传当前资质方案要求的全部材料');
              return _context15.a(2);
            case 3:
              payload = _objectSpread(_objectSpread({}, this.contextParams()), {}, {
                firstId: ids[0],
                secondId: ids[1],
                certificates: certificates
              });
              this.categorySaving = true;
              _context15.p = 4;
              if (!(this.categoryDialogMode === 'add')) {
                _context15.n = 6;
                break;
              }
              _context15.n = 5;
              return (0, _wechatOpenPlatformApi.addOpenAppCategory)(payload);
            case 5:
              _t7 = _context15.v;
              _context15.n = 8;
              break;
            case 6:
              _context15.n = 7;
              return (0, _wechatOpenPlatformApi.modifyOpenAppCategory)(payload);
            case 7:
              _t7 = _context15.v;
            case 8:
              this.categoryConfig = _t7;
              this.categoryDialogVisible = false;
              this.$message.success(this.categoryDialogMode === 'add' ? '类目已添加' : '类目已修改');
            case 9:
              _context15.p = 9;
              this.categorySaving = false;
              return _context15.f(9);
            case 10:
              return _context15.a(2);
          }
        }, _callee15, this, [[4,, 9, 10]]);
      }));
      function saveCategory() {
        return _saveCategory.apply(this, arguments);
      }
      return saveCategory;
    }(),
    removeCategory: function () {
      var _removeCategory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(row) {
        var _t8;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              _context16.p = 0;
              _context16.n = 1;
              return this.$confirm("\u786E\u8BA4\u5220\u9664\u7C7B\u76EE\u201C".concat(row.firstName, " / ").concat(row.secondName, "\u201D\uFF1F"), '删除类目', {
                type: 'warning'
              });
            case 1:
              _context16.n = 3;
              break;
            case 2:
              _context16.p = 2;
              _t8 = _context16.v;
              return _context16.a(2);
            case 3:
              _context16.n = 4;
              return (0, _wechatOpenPlatformApi.deleteOpenAppCategory)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                firstId: row.first,
                secondId: row.second
              }));
            case 4:
              this.categoryConfig = _context16.v;
              this.$message.success('类目已删除');
            case 5:
              return _context16.a(2);
          }
        }, _callee16, this, [[0, 2]]);
      }));
      function removeCategory(_x5) {
        return _removeCategory.apply(this, arguments);
      }
      return removeCategory;
    }(),
    loadPrivacy: function () {
      var _loadPrivacy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17() {
        var data, owner;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.p = _context17.n) {
            case 0:
              this.privacyLoading = true;
              _context17.p = 1;
              _context17.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppPrivacyConfig)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                privacyVersion: this.privacyVersion
              }));
            case 2:
              data = _context17.v;
              this.privacyConfig = data;
              owner = data.ownerSetting || {};
              this.privacyForm = {
                ownerSetting: {
                  contactEmail: owner.contactEmail || '',
                  contactPhone: owner.contactPhone || '',
                  contactQq: owner.contactQq || '',
                  contactWeixin: owner.contactWeixin || '',
                  extFileMediaId: owner.extFileMediaId || '',
                  noticeMethod: owner.noticeMethod || '',
                  storeExpireDays: this.parseStoreExpireDays(owner.storeExpireTimestamp)
                },
                settings: (data.settings || []).map(function (item) {
                  return {
                    privacyKey: item.privacyKey || '',
                    privacyText: item.privacyText || ''
                  };
                })
              };
            case 3:
              _context17.p = 3;
              this.privacyLoading = false;
              return _context17.f(3);
            case 4:
              return _context17.a(2);
          }
        }, _callee17, this, [[1,, 3, 4]]);
      }));
      function loadPrivacy() {
        return _loadPrivacy.apply(this, arguments);
      }
      return loadPrivacy;
    }(),
    addPrivacySetting: function addPrivacySetting() {
      var configured = this.privacyForm.settings.map(function (item) {
        return item.privacyKey;
      });
      var detected = (this.privacyConfig.privacyList || []).find(function (item) {
        return !configured.includes(item);
      });
      this.privacyForm.settings.push({
        privacyKey: detected || '',
        privacyText: ''
      });
    },
    parseStoreExpireDays: function parseStoreExpireDays(value) {
      var match = String(value || '').replace(/[\s\u3000]+/g, '').match(/^([1-9][0-9]*)天?$/);
      return match ? Number(match[1]) : null;
    },
    privacyKeyLabel: function privacyKeyLabel(key) {
      var option = this.privacyKeyOptions.find(function (item) {
        return item.key === key;
      });
      return option && option.label !== key ? "".concat(option.label, "\uFF08").concat(key, "\uFF09") : key;
    },
    savePrivacy: function () {
      var _savePrivacy = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
        var owner, ownerSetting;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.p = _context18.n) {
            case 0:
              owner = this.privacyForm.ownerSetting;
              if ([owner.contactEmail, owner.contactPhone, owner.contactQq, owner.contactWeixin].some(Boolean)) {
                _context18.n = 1;
                break;
              }
              this.$message.warning('邮箱、手机号、QQ号、微信号至少填写一种联系方式');
              return _context18.a(2);
            case 1:
              if (owner.noticeMethod) {
                _context18.n = 2;
                break;
              }
              this.$message.warning('请填写用户信息变更通知方式');
              return _context18.a(2);
            case 2:
              if (!this.privacyForm.settings.some(function (item) {
                return !item.privacyKey || !item.privacyText;
              })) {
                _context18.n = 3;
                break;
              }
              this.$message.warning('隐私信息类型和收集用途不能为空');
              return _context18.a(2);
            case 3:
              if (!(owner.storeExpireDays !== null && (!Number.isInteger(Number(owner.storeExpireDays)) || Number(owner.storeExpireDays) <= 0))) {
                _context18.n = 4;
                break;
              }
              this.$message.warning('信息存储期限请输入大于0的整数天数');
              return _context18.a(2);
            case 4:
              ownerSetting = _objectSpread(_objectSpread({}, owner), {}, {
                storeExpireTimestamp: owner.storeExpireDays === null ? '' : "".concat(Number(owner.storeExpireDays), "\u5929")
              });
              delete ownerSetting.storeExpireDays;
              this.privacySaving = true;
              _context18.p = 5;
              _context18.n = 6;
              return (0, _wechatOpenPlatformApi.saveOpenAppPrivacyConfig)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                privacyVersion: this.privacyVersion,
                ownerSetting: ownerSetting,
                settings: this.privacyForm.settings
              }));
            case 6:
              this.privacyConfig = _context18.v;
              this.$message.success('隐私保护指引已保存');
              _context18.n = 7;
              return this.loadPrivacy();
            case 7:
              _context18.p = 7;
              this.privacySaving = false;
              return _context18.f(7);
            case 8:
              return _context18.a(2);
          }
        }, _callee18, this, [[5,, 7, 8]]);
      }));
      function savePrivacy() {
        return _savePrivacy.apply(this, arguments);
      }
      return savePrivacy;
    }(),
    loadQrcodeRules: function () {
      var _loadQrcodeRules = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19() {
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.p = _context19.n) {
            case 0:
              this.qrcodeLoading = true;
              _context19.p = 1;
              _context19.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppQrcodeRuleConfig)(this.contextParams());
            case 2:
              this.qrcodeConfig = _context19.v;
            case 3:
              _context19.p = 3;
              this.qrcodeLoading = false;
              return _context19.f(3);
            case 4:
              return _context19.a(2);
          }
        }, _callee19, this, [[1,, 3, 4]]);
      }));
      function loadQrcodeRules() {
        return _loadQrcodeRules.apply(this, arguments);
      }
      return loadQrcodeRules;
    }(),
    qrcodeOpenVersionLabel: function qrcodeOpenVersionLabel(value) {
      return {
        1: '开发版',
        2: '体验版',
        3: '正式版'
      }[value] || '未知';
    },
    openQrcodeDialog: function openQrcodeDialog(row) {
      this.qrcodeForm = row ? {
        prefix: row.prefix || '',
        path: row.path || '',
        isEdit: 1,
        openVersion: row.openVersion || 2,
        permitSubRule: row.permitSubRule || 1,
        debugUrls: this.listToText(row.debugUrls)
      } : createEmptyQrcodeForm();
      this.qrcodeDialogVisible = true;
    },
    saveQrcodeRule: function () {
      var _saveQrcodeRule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20() {
        var form, debugUrls;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.p = _context20.n) {
            case 0:
              form = this.qrcodeForm;
              if (!(!form.prefix || !form.path)) {
                _context20.n = 1;
                break;
              }
              this.$message.warning('请填写二维码规则前缀和小程序页面');
              return _context20.a(2);
            case 1:
              debugUrls = this.textToList(form.debugUrls);
              if (!(debugUrls.length > 5)) {
                _context20.n = 2;
                break;
              }
              this.$message.warning('测试链接最多填写5个');
              return _context20.a(2);
            case 2:
              this.qrcodeSaving = true;
              _context20.p = 3;
              _context20.n = 4;
              return (0, _wechatOpenPlatformApi.saveOpenAppQrcodeRule)(_objectSpread(_objectSpread(_objectSpread({}, this.contextParams()), form), {}, {
                debugUrls: debugUrls
              }));
            case 4:
              this.qrcodeConfig = _context20.v;
              this.qrcodeDialogVisible = false;
              this.$message.success(form.isEdit ? '二维码规则已修改' : '二维码规则已新增');
            case 5:
              _context20.p = 5;
              this.qrcodeSaving = false;
              return _context20.f(5);
            case 6:
              return _context20.a(2);
          }
        }, _callee20, this, [[3,, 5, 6]]);
      }));
      function saveQrcodeRule() {
        return _saveQrcodeRule.apply(this, arguments);
      }
      return saveQrcodeRule;
    }(),
    publishQrcodeRule: function () {
      var _publishQrcodeRule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(row) {
        var _t9;
        return _regenerator().w(function (_context21) {
          while (1) switch (_context21.p = _context21.n) {
            case 0:
              _context21.p = 0;
              _context21.n = 1;
              return this.$confirm('发布后该二维码规则将不能修改，确认发布？', '发布二维码规则', {
                type: 'warning'
              });
            case 1:
              _context21.n = 3;
              break;
            case 2:
              _context21.p = 2;
              _t9 = _context21.v;
              return _context21.a(2);
            case 3:
              _context21.n = 4;
              return (0, _wechatOpenPlatformApi.publishOpenAppQrcodeRule)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                prefix: row.prefix
              }));
            case 4:
              this.qrcodeConfig = _context21.v;
              this.$message.success('二维码规则已发布');
            case 5:
              return _context21.a(2);
          }
        }, _callee21, this, [[0, 2]]);
      }));
      function publishQrcodeRule(_x6) {
        return _publishQrcodeRule.apply(this, arguments);
      }
      return publishQrcodeRule;
    }(),
    removeQrcodeRule: function () {
      var _removeQrcodeRule = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22(row) {
        var _t0;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.p = _context22.n) {
            case 0:
              _context22.p = 0;
              _context22.n = 1;
              return this.$confirm("\u786E\u8BA4\u5220\u9664\u4E8C\u7EF4\u7801\u89C4\u5219\u201C".concat(row.prefix, "\u201D\uFF1F"), '删除二维码规则', {
                type: 'warning'
              });
            case 1:
              _context22.n = 3;
              break;
            case 2:
              _context22.p = 2;
              _t0 = _context22.v;
              return _context22.a(2);
            case 3:
              _context22.n = 4;
              return (0, _wechatOpenPlatformApi.deleteOpenAppQrcodeRule)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                prefix: row.prefix
              }));
            case 4:
              this.qrcodeConfig = _context22.v;
              this.$message.success('二维码规则已删除');
            case 5:
              return _context22.a(2);
          }
        }, _callee22, this, [[0, 2]]);
      }));
      function removeQrcodeRule(_x7) {
        return _removeQrcodeRule.apply(this, arguments);
      }
      return removeQrcodeRule;
    }(),
    loadLocationInterfaces: function () {
      var _loadLocationInterfaces = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23() {
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.p = _context23.n) {
            case 0:
              this.locationLoading = true;
              _context23.p = 1;
              _context23.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppLocationInterfaces)(this.contextParams());
            case 2:
              this.locationConfig = _context23.v;
            case 3:
              _context23.p = 3;
              this.locationLoading = false;
              return _context23.f(3);
            case 4:
              return _context23.a(2);
          }
        }, _callee23, this, [[1,, 3, 4]]);
      }));
      function loadLocationInterfaces() {
        return _loadLocationInterfaces.apply(this, arguments);
      }
      return loadLocationInterfaces;
    }(),
    locationStatusLabel: function locationStatusLabel(status) {
      return {
        1: '待申请',
        2: '无权限',
        3: '申请中',
        4: '申请失败',
        5: '已开通'
      }[status] || '待申请';
    },
    locationStatusType: function locationStatusType(status) {
      return {
        1: 'info',
        2: 'danger',
        3: 'warning',
        4: 'danger',
        5: 'success'
      }[status] || 'info';
    },
    openLocationDialog: function openLocationDialog(row) {
      this.locationForm = _objectSpread(_objectSpread({}, createEmptyLocationForm()), {}, {
        apiName: row.apiName,
        apiChName: row.apiChName
      });
      this.locationDialogVisible = true;
    },
    applyLocationInterface: function () {
      var _applyLocationInterface = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24() {
        var form, payload, data;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              form = this.locationForm;
              if (form.content) {
                _context24.n = 1;
                break;
              }
              this.$message.warning('请填写申请原因');
              return _context24.a(2);
            case 1:
              payload = _objectSpread(_objectSpread({}, this.contextParams()), {}, {
                apiName: form.apiName,
                content: form.content,
                urlList: this.textToList(form.urlList),
                picList: this.textToList(form.picList),
                videoList: this.textToList(form.videoList)
              });
              if (!(!payload.urlList.length && !payload.picList.length && !payload.videoList.length)) {
                _context24.n = 2;
                break;
              }
              this.$message.warning('辅助网页、图片、视频至少填写一种材料');
              return _context24.a(2);
            case 2:
              if (!(payload.videoList.length > 1)) {
                _context24.n = 3;
                break;
              }
              this.$message.warning('辅助视频最多填写1个');
              return _context24.a(2);
            case 3:
              this.locationApplying = true;
              _context24.p = 4;
              _context24.n = 5;
              return (0, _wechatOpenPlatformApi.applyOpenAppLocationInterface)(payload);
            case 5:
              data = _context24.v;
              this.locationDialogVisible = false;
              this.$message.success(data && data.message || '申请已提交');
              _context24.n = 6;
              return this.loadLocationInterfaces();
            case 6:
              _context24.p = 6;
              this.locationApplying = false;
              return _context24.f(6);
            case 7:
              return _context24.a(2);
          }
        }, _callee24, this, [[4,, 6, 7]]);
      }));
      function applyLocationInterface() {
        return _applyLocationInterface.apply(this, arguments);
      }
      return applyLocationInterface;
    }(),
    loadIllegalRecords: function () {
      var _loadIllegalRecords = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25() {
        var params, start, end;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.p = _context25.n) {
            case 0:
              params = _objectSpread({}, this.contextParams());
              if (!(this.illegalDateRange && this.illegalDateRange.length === 2)) {
                _context25.n = 2;
                break;
              }
              start = Number(this.illegalDateRange[0]);
              end = Number(this.illegalDateRange[1]) + 24 * 60 * 60 * 1000 - 1;
              if (!(end - start > 90 * 24 * 60 * 60 * 1000)) {
                _context25.n = 1;
                break;
              }
              this.$message.warning('查询时间范围不能超过90天');
              return _context25.a(2);
            case 1:
              params.startTime = Math.floor(start / 1000);
              params.endTime = Math.floor(end / 1000);
            case 2:
              this.illegalLoading = true;
              _context25.p = 3;
              _context25.n = 4;
              return (0, _wechatOpenPlatformApi.getOpenAppIllegalRecords)(params);
            case 4:
              this.illegalConfig = _context25.v;
            case 5:
              _context25.p = 5;
              this.illegalLoading = false;
              return _context25.f(5);
            case 6:
              return _context25.a(2);
          }
        }, _callee25, this, [[3,, 5, 6]]);
      }));
      function loadIllegalRecords() {
        return _loadIllegalRecords.apply(this, arguments);
      }
      return loadIllegalRecords;
    }(),
    openAppealRecords: function () {
      var _openAppealRecords = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(row) {
        var data;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.p = _context26.n) {
            case 0:
              this.appealRecordsVisible = true;
              this.appealRecords = [];
              this.appealRecordsLoading = true;
              _context26.p = 1;
              _context26.n = 2;
              return (0, _wechatOpenPlatformApi.getOpenAppAppealRecords)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                illegalRecordId: row.illegalRecordId
              }));
            case 2:
              data = _context26.v;
              this.appealRecords = data && data.records || [];
            case 3:
              _context26.p = 3;
              this.appealRecordsLoading = false;
              return _context26.f(3);
            case 4:
              return _context26.a(2);
          }
        }, _callee26, this, [[1,, 3, 4]]);
      }));
      function openAppealRecords(_x8) {
        return _openAppealRecords.apply(this, arguments);
      }
      return openAppealRecords;
    }(),
    appealStatusLabel: function appealStatusLabel(status) {
      return {
        1: '处理中',
        2: '未通过',
        3: '已通过',
        4: '已撤销'
      }[status] || '未知';
    },
    appealStatusType: function appealStatusType(status) {
      return {
        1: 'warning',
        2: 'danger',
        3: 'success',
        4: 'info'
      }[status] || 'info';
    },
    openAppealDialog: function openAppealDialog(row) {
      this.appealForm = {
        illegalRecordId: row.illegalRecordId,
        appealMaterials: [createAppealMaterial()]
      };
      this.appealDialogVisible = true;
    },
    addAppealMaterial: function addAppealMaterial() {
      this.appealForm.appealMaterials.push(createAppealMaterial());
    },
    beforeAppealMediaUpload: function beforeAppealMediaUpload(file) {
      if (!/\.(jpe?g|png|bmp|gif)$/i.test(file.name || '')) {
        this.$message.warning('证明材料仅支持jpg、jpeg、png、bmp、gif格式');
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.warning('证明材料大小不能超过2MB');
        return false;
      }
      return true;
    },
    uploadAppealMaterial: function () {
      var _uploadAppealMaterial = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(options, index) {
        var item, formData, data, _t1;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.p = _context27.n) {
            case 0:
              item = this.appealForm.appealMaterials[index];
              if (item) {
                _context27.n = 1;
                break;
              }
              return _context27.a(2);
            case 1:
              formData = new FormData();
              formData.append('platformId', this.platformId);
              formData.append('companyAppId', this.companyAppId);
              formData.append('file', options.file);
              this.$set(item, 'uploading', true);
              _context27.p = 2;
              _context27.n = 3;
              return (0, _wechatOpenPlatformApi.uploadOpenAppAppealMedia)(formData);
            case 3:
              data = _context27.v;
              if (data.mediaId && !item.proofMaterialIds.includes(data.mediaId)) item.proofMaterialIds.push(data.mediaId);
              if (options.onSuccess) options.onSuccess(data);
              this.$message.success('证明材料已上传到微信');
              _context27.n = 5;
              break;
            case 4:
              _context27.p = 4;
              _t1 = _context27.v;
              if (options.onError) options.onError(_t1);
            case 5:
              _context27.p = 5;
              this.$set(item, 'uploading', false);
              return _context27.f(5);
            case 6:
              return _context27.a(2);
          }
        }, _callee27, this, [[2, 4, 5, 6]]);
      }));
      function uploadAppealMaterial(_x9, _x0) {
        return _uploadAppealMaterial.apply(this, arguments);
      }
      return uploadAppealMaterial;
    }(),
    submitAppeal: function () {
      var _submitAppeal = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28() {
        var materials, data;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.p = _context28.n) {
            case 0:
              materials = this.appealForm.appealMaterials;
              if (!materials.some(function (item) {
                return !item.reason || !item.proofMaterialIds.length;
              })) {
                _context28.n = 1;
                break;
              }
              this.$message.warning('每条申诉材料都必须填写理由并上传至少一张证明图片');
              return _context28.a(2);
            case 1:
              this.appealSubmitting = true;
              _context28.p = 2;
              _context28.n = 3;
              return (0, _wechatOpenPlatformApi.createOpenAppAppeal)(_objectSpread(_objectSpread({}, this.contextParams()), {}, {
                illegalRecordId: this.appealForm.illegalRecordId,
                appealMaterials: materials.map(function (item) {
                  return {
                    reason: item.reason,
                    proofMaterialIds: item.proofMaterialIds
                  };
                })
              }));
            case 3:
              data = _context28.v;
              this.appealDialogVisible = false;
              this.$message.success(data && data.message || '申诉已提交');
            case 4:
              _context28.p = 4;
              this.appealSubmitting = false;
              return _context28.f(4);
            case 5:
              return _context28.a(2);
          }
        }, _callee28, this, [[2,, 4, 5]]);
      }));
      function submitAppeal() {
        return _submitAppeal.apply(this, arguments);
      }
      return submitAppeal;
    }()
  }
};